import './expensibleStamp.css';

export default function ExpensibleStamp() {
    return (
        <div>
            <svg width="102" height="128" viewBox="0 0 102 128" classNmae="expensible-stamp">
            <g id="Group_32" data-name="Group 32" transform="translate(-193 -572)">
                <circle id="Ellipse_2" data-name="Ellipse 2" cx="51" cy="51" r="51" transform="translate(193 586)" fill="#88cdf6"/>
                <path id="Path_2" data-name="Path 2" d="M31.3,74.012c5.921,0,8.564-4.969,8.564-9.3,0-5.921-3.172-9.516-8.564-9.516H25.058c-2.538,0-4.229-1.692-4.229-4.546S22.521,46.1,25.058,46.1h5.815c5.075,0,7.613-4.546,7.613-9.093,0-4.969-2.538-9.093-7.613-9.093H25.058c-2.538,0-4.229-1.692-4.229-4.546s1.692-4.546,4.229-4.546H31.3c5.921,0,8.564-4.969,8.564-9.3C39.861,3.595,36.689,0,31.3,0H10.785C2.855,0,0,5.392,0,12.793V61.218c0,7.4,2.855,12.793,10.785,12.793Z" transform="matrix(0.966, -0.259, 0.259, 0.966, 214.649, 605.934)" fill="#f8fdff"/>
                <ellipse id="Ellipse_3" data-name="Ellipse 3" cx="5.5" cy="6" rx="5.5" ry="6" transform="translate(219 572)" fill="#88cdf6"/>
                <circle id="Ellipse_4" data-name="Ellipse 4" cx="6" cy="6" r="6" transform="translate(260 688)" fill="#88cdf6"/>
            </g>
            </svg>
        </div>
    )
}